import type { RecipeMeal } from "../services/backendTypes";

// eslint-disable-next-line import/prefer-default-export
export function getTestIDForRecipeMeal(recipeMeal: RecipeMeal): string {
  return `planned-recipeMeal-${recipeMeal.recipe_template.source_provider}-${
    recipeMeal.recipe_template.id || "MISSING_ID"
  }`;
}
